// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"roleModal__wrapper","checkbox":"roleModal__checkbox","stuck":"roleModal__stuck","label_and":"roleModal__label_and"};